/* HEADER PC COLLECTIONS */
$('.fs-mainmenu-collections-pc').on('click',function(){
     $('.fs-collectionmenu-pc').css('display','block');
});

$(window).on('mousemove', function(e) {
  var menuy1 = $('.fs-collectionmenu-pc').offset().top;
  var menuy2 = $('.fs-collectionmenu-pc').outerHeight();
  var menuy = menuy1 + menuy2;
  var mousey = e.clientY;
  if (mousey > menuy) {
     $('.fs-collectionmenu-pc').css('display','none');
  }
});


/* Sidemenu */
$(function(){
	$(".fs-sidemenu-parent:has(.open-child)").addClass("current-parent");
	$(".fs-sidemenu-chind-ul:has(.open-child)").addClass("open");
});

/* PC - SIDEMENU */
/*
$('.fs-sidemenu-parent-link').on('click',function(){
  if($(this).parent().children('.fs-sidemenu-chind-ul').hasClass('open')){
     $(this).parent().children('.fs-sidemenu-chind-ul').removeClass('open');
  } else {
     $(this).parent().children('.fs-sidemenu-chind-ul').addClass('open');
  }
});
*/

/* SP - Humberger */
$('.fs-hamburger-lines').on('click',function(){
  if($(this).hasClass('fs-hamburger-open')){
     $(this).removeClass('fs-hamburger-open');
     $('.fs-hamburger-menu').removeClass('fs-hamburger-menu-open');
     $('.main-content').css('position','initial');

  } else {
     $(this).addClass('fs-hamburger-open');
     $('.fs-hamburger-menu').addClass('fs-hamburger-menu-open');
     $('.main-content').css('position','fixed');

  }
});

$('.fs-2slide-webstore').css('left','100%'); 
$('.fs-2slide-collections').css('left','100%'); 

function webstore(){
  if($('.fs-mainmenu-web-store').parent().hasClass('fs-slidemove_after')){
     $('.fs-mainmenu-web-store').parent().removeClass('fs-slidemove_after');
     $('.fs-mainmenu-web-store').parent().addClass('fs-slidemove_before');
     $('.fs-2slide-webstore').css('left','100%'); 
  } else {
     $('.fs-mainmenu-web-store').parent().addClass('fs-slidemove_after');
     $('.fs-mainmenu-web-store').parent().removeClass('fs-slidemove_before');
     $('.fs-2slide-webstore').css('left','0'); 
  }
}
$('.fs-mainmenu-web-store').on('click',function(){
	webstore();
});
$('.fs-slideback1').on('click',function(){
	webstore();
});
function collections(){
  if($('.fs-mainmenu-collections').parent().hasClass('fs-slidemove_after')){
     $('.fs-mainmenu-collections').parent().removeClass('fs-slidemove_after');
     $('.fs-mainmenu-collections').parent().addClass('fs-slidemove_before');
     $('.fs-2slide-collections').css('left','100%'); 
  } else {
     $('.fs-mainmenu-collections').parent().addClass('fs-slidemove_after');
     $('.fs-mainmenu-collections').parent().removeClass('fs-slidemove_before');
     $('.fs-2slide-collections').css('left','0'); 
  }
}
$('.fs-mainmenu-collections').on('click',function(){
	collections();
});
$('.fs-slideback2').on('click',function(){
	collections();
});


/* SP - Filter */
$('.fs-filter-button-sp').on('click',function(){
  if($('.fs-sidemenu').hasClass('fs-sidemenu-open')){
     /* CLOSE */
     $('.fs-filter-button-sp').removeClass('fs-sort-sp-open-current');
     $('.fs-sort-button-sp').removeClass('fs-sort-sp-open-current');
     $('.fs-sidemenu').removeClass('fs-sidemenu-open');
     $('.fs-sidemenu-outarea-sp').css('display','none');
     $('.collection__products').css('position','unset');
     $('.collection__products').css('top','unset');
     $('#shopify-section-footer').css('display','block');
  } else {
     /* OPEN */
     $('.fs-filter-button-sp').addClass('fs-sort-sp-open-current');
     $('.fs-sort-button-sp').removeClass('fs-sort-sp-open-current');
     $('.fs-sidemenu').addClass('fs-sidemenu-open');
     $('.fs-sidemenu-outarea-sp').css('display','block');
     $('.collection__products').css('position','fixed');
     if ($('.announcement__wrapper').hassClass('.announcement__wrapper--top')) {
     $('.collection__products').css('top','166px');
     } else {
     $('.collection__products').css('top','116px');
     }
     $('#shopify-section-footer').css('display','none');
     $('.fs-sort-sp').removeClass('fs-sort-sp-open');
     $('.fs-sort-sp').addClass('fs-sort-sp-close');    
  }
});
$('.fs-sidemenu-outarea-sp').on('click',function(){
     /* CLOSE */
     $('.fs-filter-button-sp').removeClass('fs-sort-sp-open-current');
     $('.fs-sort-button-sp').removeClass('fs-sort-sp-open-current');
     $('.fs-sidemenu').removeClass('fs-sidemenu-open');
     $('.fs-sidemenu-outarea-sp').css('display','none');
     $('.collection__products').css('position','unset');
     $('.collection__products').css('top','unset');
     $('#shopify-section-footer').css('display','block');
});


/* SP - Sort */
$('.fs-sort-button-sp').on('click',function(){
  if($('.fs-sort-sp').hasClass('fs-sort-sp-open')){
     /* CLOSE */
     $('.fs-filter-button-sp').removeClass('fs-sort-sp-open-current');
     $('.fs-sort-button-sp').removeClass('fs-sort-sp-open-current');
     $('.fs-sort-sp').removeClass('fs-sort-sp-open');
     $('.fs-sort-sp').addClass('fs-sort-sp-close');
  } else {
     /* OPEN */
     $('.fs-filter-button-sp').removeClass('fs-sort-sp-open-current');
     $('.fs-sort-button-sp').addClass('fs-sort-sp-open-current');
     $('.fs-sort-sp').addClass('fs-sort-sp-open');
     $('.fs-sort-sp').removeClass('fs-sort-sp-close');
     $('.fs-sidemenu').removeClass('fs-sidemenu-open');
     $('.fs-sidemenu-outarea-sp').css('display','none');
     $('.collection__products').css('position','unset');
     $('.collection__products').css('top','unset');
     $('#shopify-section-footer').css('display','block');    
  }
});


/* PC -SWATCH hover */
$('.swatch__button').hover(
  function () {
    $('.swatch__button').find('.fs-tooltip').remove();
    var color = $(this).data('tooltip');
    $(this).append('<div class="fs-tooltip">'+color+'</div>');
  },
  function () {
    //$('.swatch__button').find('.fs-tooltip').remove();
  }
);
$(function(){
  var checked = $("input[type='radio']:checked");
  //console.log('checked: '+checked);
  var color = $(checked).parent('.swatch__button').data('tooltip');
  //console.log('color: '+color);
  $(checked).parent('.swatch__button').append('<div class="fs-tooltip">'+color+'</div>');
});
